// src/modules/app-views/serviceOrders/components/FilterDrawerBody.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DatePicker, Segmented, Form } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const FilterDrawerBody = ({ listContext }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { setDrawerFilter, query } = listContext || {};
  const drawerType = query?.drawer?.type || 'all';

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleTypeChange = value => {
    setDrawerFilter?.({ type: value === 'all' ? undefined : value });
  };

  const handleDateRangeChange = dates => {
    if (dates && dates[0] && dates[1]) {
      setDrawerFilter?.({
        dateFrom: dates[0].toISOString(),
        dateTo: dates[1].toISOString(),
      });
    } else {
      setDrawerFilter?.({ dateFrom: undefined, dateTo: undefined });
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div>
      {/* Filter by type */}
      <Form.Item label={translateX('filter_by_type')}>
        <Segmented
          options={[
            { label: translateX('all_types'), value: 'all' },
            { label: translateX('budget'), value: 'budget' },
            { label: translateX('order'), value: 'order' },
          ]}
          value={drawerType || 'all'}
          onChange={handleTypeChange}
          block
        />
      </Form.Item>

      {/* Filter by date range */}
      <Form.Item label={translateX('period')}>
        <DatePicker.RangePicker
          style={{ width: '100%' }}
          onChange={handleDateRangeChange}
          format="DD/MM/YYYY"
        />
      </Form.Item>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default FilterDrawerBody;

// *******************************************************************************
// HELPERS
// *******************************************************************************
